export default __webpack_public_path__ + "src/assets/csv/new-location-request-form.csv";